import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'administrator-role-merges';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getStoresOfManager() {
  return get({
    url: `${url}/manager-stores`,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url: url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
